import { domClassMerge } from '@propertyfinder/helpers';
import { FunctionComponent, h } from 'preact';

import { PropertyModel } from 'common/data/property/model';
import { TagNewComponent } from 'common/module/tag-new/component';

import { tagListGetItems } from './get-items';
import { TagListItemType } from './item.type';

export const TagListComponent: FunctionComponent<{
  className?: string;
  property: PropertyModel;
  tags?: TagListItemType[];
}> = ({ className, property, tags = tagListGetItems(property) }) => {
  return (
    <div className={domClassMerge('tag-list', className)}>
      {tags?.length > 0 &&
        tags.map((item) =>
          typeof item === 'object' ? (
            <TagNewComponent additionalText={item.text} type={item.type} />
          ) : (
            <TagNewComponent type={item} />
          )
        )}
    </div>
  );
};
